// Considered: the former in-cover applicability block (ContextCoverCardMolecule column B) —
// rejected as the rail host because it isn't a rail surface at all; this molecule is a thin
// header (mirrors ContextRootInspectorMolecule's icon/eyebrow/title chrome) wrapping
// ApplicabilityEditorMolecule's body, so the editor itself stays reusable across template
// applicability surfaces (Phase 8) that don't share the context editor's rail chrome. See spec
// context-selector-editor.md Phase 5 (SC3) Reuse Audit — "the Inspector is a thin rail host of
// the Editor (shares this row)".
import React from 'react';
import { useTranslation } from 'localization';
import ApplicabilityEditorMolecule from '../ApplicabilityEditor/ApplicabilityEditorMolecule';
import type { ApplicabilityEditorMoleculeProps } from '../ApplicabilityEditor/ApplicabilityEditorMolecule';
import './ApplicabilityInspectorMolecule.scss';

export type ApplicabilityInspectorMoleculeProps = ApplicabilityEditorMoleculeProps;

const ApplicabilityInspectorMolecule: React.FC<ApplicabilityInspectorMoleculeProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="applicability-inspector-molecule" data-testid="applicability-inspector">
      <div className="applicability-inspector-molecule__header">
        <span className="applicability-inspector-molecule__icon" aria-hidden="true">
          <i className="pi pi-filter" />
        </span>
        <div className="applicability-inspector-molecule__title-group">
          <div className="applicability-inspector-molecule__eyebrow">
            {t('context.editor.inspector.applicability.eyebrow')}
          </div>
          <div className="applicability-inspector-molecule__title">
            {t('context.editor.inspector.applicability.title')}
          </div>
        </div>
      </div>

      <div className="applicability-inspector-molecule__body">
        <ApplicabilityEditorMolecule {...props} />
      </div>
    </div>
  );
};

export default ApplicabilityInspectorMolecule;
